module.exports = __webpack_public_path__ + "static/media/PÖfi-logo.32447992.svg";